import { useParams, Navigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { getBatchDetails } from '../../apis/repository';
import BatchPackageList from '../Repository/BatchPackageList';
import { useSubscription } from '../../hooks/useSubscription';

const DEFAULT_PAGE_SIZE = 10;

const BatchPackageListWrapper = () => {
    const { batch_id } = useParams();
    const batchId = batch_id ? parseInt(batch_id) : null;
    const [batchDetails, setBatchDetails] = useState(null);
    const [loading, setLoading] = useState(false);
    const { isTrial, isActive } = useSubscription();

    // Redirect to pricing if Trial or inactive subscription
    if (isTrial || !isActive) {
        return <Navigate to="/pricing" replace />;
    }

    useEffect(() => {
        const loadBatchDetails = async () => {
            if (!batchId) return;

            setLoading(true);
            try {
                const response = await getBatchDetails(batchId);
                setBatchDetails(response);
            } catch (error) {
                console.error('Error loading batch details:', error);
                toast.error('Failed to load batch details');
                setBatchDetails(null);
            } finally {
                setLoading(false);
            }
        };

        loadBatchDetails();
    }, [batchId]);

    return <BatchPackageList pageSize={DEFAULT_PAGE_SIZE} batchId={batchId} batchDetails={batchDetails} />;
};

export default BatchPackageListWrapper;

